export const SaleTypeEnum = {
    Retail: 1,
    DirectSales : 2,
    Total: 3,

    getKeyEnum(value) {
        return Object.keys(this).findOrFirst(x => this[x] === value);
    }
};



// WEBPACK FOOTER //
// ./src/enuns/saleType.enum.js